export default {
  get(id) {
    return Vue.http.get(`clients/${id}`).then(response => response.data.data)
  }
}
